module.exports = __webpack_public_path__ + "static/media/icon-gear.d24f9172.webp";